// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedPromoCode: Object,
};

const DeletePromoCode = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedPromoCode,
  } = props;

  const DeleteSelectedItem = () => {
    submit(selectedPromoCode.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={DeleteSelectedItem} type="danger">Delete</SpButton>,
      ]}
      title="Delete Promo Code"
    >
      <div className="px-4">
        <div className="mt-1 mb-2">Are you sure you want to delete this promo code?</div>
        <SpH5>
          <div>
            {
              (selectedPromoCode && selectedPromoCode.promotionalCodes)
                ? (selectedPromoCode.promotionalCodes && selectedPromoCode.promotionalCodes.code)
                : <>&#8211;</>
            }
          </div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeletePromoCode;
